// rules.jsx
import React, { useEffect } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setBackButtonUrl } from '../uiSlice';
import { s3ThemeAssetUrl } from '../../utils/themeAssets';

const PUBLIC = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const rulesIconSrc = `${PUBLIC}/img/rules-icon.png`;

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: themeData } = useSelector((state) => state.theme);
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate('/game');
  };

  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  const themeTextColorStyle = { ...(themeData?.text_color && { color: themeData.text_color }) };

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-top">
          <img
            src={s3ThemeAssetUrl(themeData?.logo)}
            alt="World Charms"
            className="user-rules-image"
          />
        </div>
        <div className="user-rules-bottom">
          <div className="user-rules-big-title" style={themeTextColorStyle}>
            {themeData?.main_title}
          </div>
          {/* <div className="user-rules-subline">
            {themeData?.landing_page_title}
          </div> */}
          <div className="user-rules-heading" style={{
                ...(themeData?.button_backgroundcolor && { backgroundColor: themeData.button_backgroundcolor }),
                ...(themeData?.button_color && { color: themeData.button_color }),
              }}>How to play</div>
          <ul className="user-rules-list" style={themeTextColorStyle}>
            {
              (Array.isArray(themeData?.rules) ? themeData.rules : []).map((rules, index) => (
                <li key={index}>
                  <img
                    src={rulesIconSrc}
                    alt=""
                    className="user-rule-bullet"
                    width={28}
                    height={28}
                    draggable={false}
                  />
                  <span className="user-rule-text">{rules}</span>
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button style={{
                ...(themeData?.button_backgroundcolor && { backgroundColor: themeData.button_backgroundcolor }),
                ...(themeData?.button_color && { color: themeData.button_color }),
              }}
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserRules;
